module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.cols), function(col) {
    return _c('v-flex', {
      key: col.value,
      class: _vm.classWidth,
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-toolbar', {
      attrs: {
        "dense": "",
        "flat": "",
        "dark": ""
      }
    }, [_c('v-btn', {
      staticClass: "visible-xs-only",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleCol(col)
        }
      }
    }, [(_vm.visible[col.value]) ? _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("expand_less")]) : _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("expand_more")])], 1), _vm._v(" "), _c('v-badge', {
      attrs: {
        "right": "",
        "color": "cyan"
      }
    }, [_c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(_vm.getItems(col.value).length) + " ")]), _vm._v(" "), _c('h3', {
      staticClass: "subheading"
    }, [_vm._v(_vm._s(col.text))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.withSearch) ? _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.showSearch = !_vm.showSearch
        }
      }
    }, [_c('v-icon', [_vm._v("search")])], 1) : _vm._e(), _vm._v(" "), (col.summary(_vm.getItems(col.value))) ? _c('span', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(col.summary(_vm.getItems(col.value))))]) : _vm._e(), _vm._v(" "), (_vm.showSearch) ? _c('v-text-field', {
      attrs: {
        "slot": "extension",
        "transition": "slide-y-transition"
      },
      slot: "extension"
    }) : _vm._e()], 1), _vm._v(" "), (_vm.visible[col.value]) ? _c('div', [_vm._t("list", function() {
      return [_c('v-list', {
        attrs: {
          "dense": ""
        }
      }, _vm._l((_vm.getItems(col.value)), function(item) {
        return _c('v-list-tile', {
          key: item.id
        }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
      }), 1)]
    }, {
      "items": _vm.getItems(col.value),
      "col": col
    })], 2) : _vm._e(), _vm._v(" "), _c('v-divider')], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04e4816b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/layout/Kanban.vue
// module id = 1315
// module chunks = 9